import React from 'react';
import { connect } from 'react-redux';
import { userActions } from '../actions';
import logo from '../img/lowi_logo.png'
import { bake_cookie,versionCookie, read_cookie } from '../helpers/cookieHelper';
// import FacebookLogin from 'react-facebook-login';

function mapStateToProps(state) {
    const { loggingIn } = state.authentication;
    return {
        loggingIn
    };
}

// TODO: 30分鐘 logout
class LoginPage extends React.Component {
    constructor(props) {
        super(props);

        // reset login status
        // this.props.dispatch(userActions.logout());

        this.state = {
            username: '',
            password: '',
            submitted: false,
            isButtonDisabled: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onLaunchClicked = this.onLaunchClicked.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });
        const { username, password } = this.state;
        const { dispatch } = this.props;
        if (username && password) {
            dispatch(userActions.login(username, password));
        }
    }

    onLaunchClicked (event) {
        event.preventDefault();
        this.setState({
            isButtonDisabled: true
        });
        setTimeout(() => this.setState({ isButtonDisabled: false }), 3000);
    }

    cookieChecker =()=>{
        const version = read_cookie(versionCookie)
        if(!version){
          bake_cookie(versionCookie,{verlist:[]})
        }
      }

    componentDidMount(){
    this.cookieChecker();
    }

    render() {
        const { loggingIn } = this.props;
        const { username, password, submitted } = this.state;
        // const responseFacebook = (response) => {
        //     console.log(response);
        // };
        // if (responseFacebook.accessToken) {
        //   const { dispatch } = this.props;
        //   dispatch(userActions.logFB(responseFacebook.accessToken));
        // }
        return (
          <div className='login-container'>
            <div className="col-md-6 col-md-offset-3 login-container__block">
              <div className="neuf-logo">
                <img src={logo} alt="neuf-logo"/>
              </div>
              <h2>LINK OF WISE INFORMATION</h2>
              <form className='form' name="form" onSubmit={this.handleSubmit}>
                  <div className={'form-group' + (submitted && !username ? ' has-error' : '')}>
                      <label htmlFor="username">使用者名稱</label>
                      <input type="text" className="form-control" name="username" value={username} onChange={this.handleChange} />
                      {submitted && !username &&
                          <div className="help-block">Username is required</div>
                      }
                  </div>
                  <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                      <label htmlFor="password">密碼</label>
                      <input type="password" className="form-control" name="password" value={password} onChange={this.handleChange} />
                      {submitted && !password &&
                          <div className="help-block">Password is required</div>
                      }
                  </div>
                  <div className='login-button'>
                      <button className="btn btn-primary" onClick={ loggingIn && this.onLaunchClicked} disabled={this.state.isButtonDisabled}>登入</button>
                  </div>
              </form>
            </div>
          </div>
        );
    }
}

const connectedLoginPage = connect(mapStateToProps)(LoginPage);
export { connectedLoginPage as LoginPage };



// WEBPACK FOOTER //
// ./src/components/LoginPage.js